import React, { Component } from 'react';
import ApiService from '../modules/ApiService';
import { AppBar, Toolbar, Avatar, Typography, IconButton, Tooltip } from '@material-ui/core';
import { ExitToApp } from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
const Auth = new ApiService();

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    textAlign: "center",
    marginLeft: "50px"
  },
});

class TopBar extends Component {

  
  constructor(props) {
    super(props)
    console.log(props)
    this.handleLogout = this.handleLogout.bind(this)
  }


  handleLogout(){
    Auth.logout()
    this.props.history.replace('/login');

  }

  render() {
    const classes = this.props.classes
    return (
      <div className={classes.root}>
        <Toolbar position="sticky">
                {/* <Toolbar> */}
                    <Typography className={classes.title} variant="h6">
                        {this.props.title}
                    </Typography>
                    { this.props.user && (
                        <React.Fragment>
                          
                          <Tooltip title={this.props.user.Name}>
                            <IconButton>
                              <Avatar src={'https://www.do.ektu.kz/PReports/Cards/EmployeePhoto.asp?EmployeeID=' + this.props.user.EmployeeID}/>
                            </IconButton>
                          </Tooltip>
                          <Tooltip title={"Выйти из системы"}>
                            <IconButton onClick={this.handleLogout}>
                              <ExitToApp/>
                            </IconButton>
                          </Tooltip>

                        </React.Fragment>
                    )}
                {/* </Toolbar> */}
            </Toolbar>
           
      </div>
    );
  }
}

export default  withStyles(styles)(TopBar) ;
